import { useAuth } from "oidc-react";
import { useEffect, } from "react";
import { useParams } from "react-router-dom";


const Login = () => {
  const auth = useAuth();
  const { idp } = useParams();
  const message = idp
    ? 'Logging in...'
    : `An Identity Provider must be specified. Try ${window.location.protocol}://${window.location.host}/login/{your_idp}`;

  useEffect(() => {
    const signIn = async () => {
      await auth.userManager.signinRedirect({ 'acr_values': `idp:${idp}`})
    };
  
    if (idp && auth.userManager) {
      signIn();
    }
  }, [idp, auth.userManager]);

  return (
    <div>
      <p>{message}</p>
    </div>
  );
};

export default Login;